/** i18n + derived labels for PlanPage header chips. */
export function buildPlanPageHeaderLabels(
  t,
  { canUsePlanMode, planMode, isAgendaEnabled, canUseAgenda },
) {
  const planModeTitle = !canUsePlanMode
    ? t('plan.planModeNeedsProject', 'Selecteer precies 1 project om te plannen')
    : planMode
      ? t('plan.planModeHide', 'Plan modus uitzetten')
      : t('plan.planModeShow', 'Plan modus aanzetten');

  return {
    planModeLabel: t('plan.planMode', 'Plan modus'),
    planModeTitle,
    agendaLabel: t('plan.agenda', 'Calendar'),
    agendaTitle: !canUseAgenda
      ? t('plan.agendaLocked', 'Google Calendar sync (Lite feature)')
      : isAgendaEnabled
        ? t('plan.agendaHide', 'Hide calendar')
        : t('plan.agendaShow', 'Show calendar'),
  };
}
